
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desk = window.matchMedia('(min-width: 1024px)');
  function hdrH(){ return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr')) || 72; }
  function inView(el, cb, opts){
    if (!('IntersectionObserver' in window)){ cb(true); return; }
    new IntersectionObserver(function(es){ es.forEach(function(e){ cb(e.isIntersecting, e); }); }, opts || {}).observe(el);
  }

  /* ---- Jour en cours (heure de Paris) : horaires surlignés ---- */
  function parisDay(){
    try { var d = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris', weekday:'short'}).format(new Date()); return {Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[d]; }
    catch(e){ return new Date().getDay(); }
  }
  var today = parisDay();
  [].forEach.call(document.querySelectorAll('.hours tr[data-day]'), function(tr){
    if (+tr.dataset.day === today){ tr.classList.add('today'); var t = document.querySelector('[data-today]'); if (t) t.textContent = tr.querySelector('td').textContent; }
  });

  /* ---- Copier l'adresse ---- */
  [].forEach.call(document.querySelectorAll('[data-copy]'), function(b){
    b.addEventListener('click', function(){
      var txt = b.dataset.copy, lab = b.querySelector('span');
      function ok(){ b.classList.add('done'); lab.textContent = 'Adresse copiée'; setTimeout(function(){ b.classList.remove('done'); lab.textContent = "Copier l'adresse"; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(ok, function(){ lab.textContent = txt; }); }
      else { lab.textContent = txt; }
    });
  });

  /* ---- Calendrier des matchs à domicile (rclens.fr, relevé le 31/10/2026). Dans Shopify : liste modifiable par l'équipe ---- */
  var FIX = [
    {d:'2026-11-04T21:00:00+01:00', opp:'Côme'},
    {d:'2026-11-08T20:45:00+01:00', opp:'Marseille'},
    {d:'2026-11-21T20:45:00+01:00', opp:'Toulouse'},
    {d:'2026-12-05T20:45:00+01:00', opp:'Le Havre', tbc:true},
    {d:'2026-12-09T21:00:00+01:00', opp:'Bodø/Glimt'},
    {d:'2027-01-03T20:45:00+01:00', opp:'Paris SG'},
    {d:'2027-01-20T21:00:00+01:00', opp:'Manchester City'},
    {d:'2027-01-23T20:45:00+01:00', opp:'Brest', tbc:true}
  ];
  function nextMatch(now){
    for (var i = 0; i < FIX.length; i++){ var t = Date.parse(FIX[i].d); if (now < t + 2 * 3600e3) return {f:FIX[i], t:t}; }
    return null;
  }
  var mFmt = new Intl.DateTimeFormat('fr-FR', {timeZone:'Europe/Paris', weekday:'long', day:'numeric', month:'long', hour:'2-digit', minute:'2-digit'});
  function matchLabel(m){
    var o = {}; mFmt.formatToParts(new Date(m.t)).forEach(function(p){ o[p.type] = p.value; });
    return o.weekday.charAt(0).toUpperCase() + o.weekday.slice(1) + ' ' + o.day + ' ' + o.month + ' · ' + o.hour + 'h' + o.minute + (m.f.tbc ? ' (horaire à confirmer)' : '');
  }

  /* ---- Hero : « LENS » dessiné en relief (profondeur qui suit la souris), supportrice, damier ---- */
  var GLYPHS = {"letters":[{"adv":0.7634,"contours":[[[0.2901,0.0],[0.131,0.0],[0.1074,0.002],[0.0902,0.0083],[0.0788,0.0195],[0.0724,0.0362],[0.0704,0.0592],[0.0704,0.9408],[0.0724,0.9638],[0.0788,0.9805],[0.0902,0.9918],[0.1074,0.998],[0.131,1.0],[0.6887,1.0],[0.7117,0.998],[0.7284,0.9918],[0.7396,0.9805],[0.7459,0.9638],[0.7479,0.9408],[0.7479,0.8127],[0.7459,0.7892],[0.7396,0.7724],[0.7284,0.7614],[0.7117,0.7553],[0.6887,0.7535],[0.3493,0.7535],[0.3493,0.0592],[0.3475,0.0362],[0.3414,0.0195],[0.3304,0.0083],[0.3136,0.002]]]},{"adv":0.8282,"contours":[[[0.7211,0.0],[0.131,0.0],[0.1074,0.002],[0.0902,0.0083],[0.0788,0.0195],[0.0724,0.0362],[0.0704,0.0592],[0.0704,0.9408],[0.0724,0.9638],[0.0788,0.9805],[0.0902,0.9918],[0.1074,0.998],[0.131,1.0],[0.7338,1.0],[0.7567,0.998],[0.7735,0.9918],[0.7847,0.9805],[0.791,0.9638],[0.793,0.9408],[0.793,0.8127],[0.791,0.7892],[0.7847,0.7724],[0.7735,0.7614],[0.7567,0.7553],[0.7338,0.7535],[0.3493,0.7535],[0.3493,0.6183],[0.6465,0.6183],[0.6701,0.6163],[0.6873,0.61],[0.6987,0.5985],[0.7051,0.5814],[0.707,0.5577],[0.707,0.431],[0.7051,0.4081],[0.6987,0.3913],[0.6873,0.3801],[0.6701,0.3738],[0.6465,0.3718],[0.3493,0.3718],[0.3493,0.2465],[0.7211,0.2465],[0.7447,0.2445],[0.7619,0.2381],[0.7733,0.2267],[0.7797,0.2095],[0.7817,0.1859],[0.7817,0.0592],[0.7797,0.0362],[0.7733,0.0195],[0.7619,0.0083],[0.7447,0.002]]]},{"adv":0.9859,"contours":[[[0.8563,0.0],[0.7127,0.0],[0.6892,0.002],[0.6724,0.0083],[0.6614,0.0195],[0.6553,0.0362],[0.6535,0.0592],[0.6535,0.2901],[0.6537,0.3134],[0.6542,0.3354],[0.6551,0.3563],[0.6563,0.3763],[0.6579,0.3955],[0.6599,0.4141],[0.6623,0.4323],[0.6651,0.4501],[0.6683,0.4678],[0.6719,0.4855],[0.676,0.5033],[0.6804,0.5215],[0.6854,0.5402],[0.6907,0.5596],[0.6966,0.5797],[0.7029,0.6008],[0.7169,0.6465],[0.7056,0.6465],[0.6965,0.6243],[0.6881,0.6036],[0.6805,0.5841],[0.6664,0.5478],[0.6597,0.5307],[0.6528,0.5139],[0.6457,0.4973],[0.6382,0.4806],[0.63,0.4636],[0.621,0.4461],[0.611,0.428],[0.5999,0.4089],[0.5873,0.3887],[0.3563,0.0282],[0.3426,0.0121],[0.3241,0.0029],[0.2972,0.0],[0.131,0.0],[0.1074,0.002],[0.0902,0.0083],[0.0788,0.0195],[0.0724,0.0362],[0.0704,0.0592],[0.0704,0.9408],[0.0724,0.9638],[0.0788,0.9805],[0.0902,0.9918],[0.1074,0.998],[0.131,1.0],[0.2732,1.0],[0.2969,0.998],[0.314,0.9918],[0.3255,0.9805],[0.3318,0.9638],[0.3338,0.9408],[0.3338,0.7113],[0.3337,0.686],[0.3332,0.6621],[0.3324,0.6395],[0.3313,0.6179],[0.33,0.5974],[0.3283,0.5776],[0.3264,0.5585],[0.3242,0.5399],[0.3216,0.5216],[0.3189,0.5036],[0.3158,0.4856],[0.3125,0.4674],[0.309,0.4491],[0.3051,0.4303],[0.301,0.4109],[0.2873,0.3479],[0.2986,0.3479],[0.3056,0.371],[0.3123,0.3928],[0.3188,0.4134],[0.3253,0.433],[0.3317,0.4518],[0.3382,0.4698],[0.3448,0.4872],[0.3516,0.504],[0.3587,0.5206],[0.3661,0.5369],[0.374,0.5532],[0.3824,0.5695],[0.3913,0.586],[0.401,0.6029],[0.4113,0.6201],[0.4225,0.638],[0.6394,0.9718],[0.6535,0.9879],[0.6719,0.9971],[0.6972,1.0],[0.8563,1.0],[0.8793,0.998],[0.896,0.9918],[0.9073,0.9805],[0.9135,0.9638],[0.9155,0.9408],[0.9155,0.0592],[0.9135,0.0362],[0.9073,0.0195],[0.896,0.0083],[0.8793,0.002]]]},{"adv":0.9113,"contours":[[[0.0394,0.2944],[0.0406,0.3273],[0.0441,0.3577],[0.0497,0.3859],[0.0573,0.4118],[0.0668,0.4355],[0.0781,0.4573],[0.091,0.4771],[0.1054,0.4951],[0.1212,0.5114],[0.1382,0.5261],[0.1564,0.5393],[0.1755,0.5511],[0.1955,0.5615],[0.2162,0.5708],[0.2376,0.5789],[0.2594,0.5861],[0.2815,0.5923],[0.3039,0.5978],[0.3263,0.6026],[0.3487,0.6068],[0.3709,0.6105],[0.3928,0.6138],[0.4143,0.6169],[0.4352,0.6197],[0.46,0.6233],[0.4835,0.6271],[0.5055,0.6315],[0.5258,0.6364],[0.5441,0.6422],[0.5602,0.6489],[0.5739,0.6568],[0.585,0.6659],[0.5932,0.6765],[0.5983,0.6888],[0.6,0.7028],[0.5983,0.7198],[0.5934,0.7344],[0.5853,0.7469],[0.5741,0.7572],[0.56,0.7657],[0.5431,0.7723],[0.5235,0.7772],[0.5012,0.7806],[0.4764,0.7825],[0.4493,0.7831],[0.4239,0.7822],[0.4003,0.7794],[0.3786,0.7747],[0.3588,0.7682],[0.341,0.7599],[0.3251,0.7497],[0.3114,0.7378],[0.2997,0.724],[0.2901,0.7085],[0.2774,0.6882],[0.2639,0.6758],[0.2485,0.6705],[0.2299,0.6714],[0.207,0.6775],[0.0746,0.7254],[0.0535,0.7353],[0.0391,0.7471],[0.0316,0.7618],[0.0307,0.78],[0.0366,0.8028],[0.0438,0.8207],[0.0519,0.8379],[0.061,0.8542],[0.071,0.8699],[0.0819,0.8847],[0.0937,0.8987],[0.1064,0.912],[0.12,0.9245],[0.1345,0.9363],[0.1498,0.9472],[0.1659,0.9575],[0.1829,0.9669],[0.2007,0.9756],[0.2193,0.9835],[0.2387,0.9907],[0.2588,0.9971],[0.2798,1.0027],[0.3014,1.0076],[0.3238,1.0117],[0.347,1.0151],[0.3708,1.0177],[0.3953,1.0196],[0.4206,1.0208],[0.4465,1.0211],[0.4773,1.0205],[0.5074,1.0188],[0.5368,1.0158],[0.5654,1.0117],[0.5931,1.0065],[0.6199,1.0001],[0.6457,0.9925],[0.6705,0.9839],[0.6942,0.9741],[0.7167,0.9632],[0.7381,0.9513],[0.7583,0.9382],[0.7771,0.9241],[0.7946,0.9089],[0.8107,0.8926],[0.8253,0.8753],[0.8384,0.8569],[0.8499,0.8375],[0.8598,0.8171],[0.8681,0.7957],[0.8746,0.7732],[0.8793,0.7498],[0.8821,0.7254],[0.8831,0.7],[0.882,0.6679],[0.8789,0.6381],[0.8737,0.6104],[0.8667,0.5848],[0.8579,0.5613],[0.8475,0.5396],[0.8356,0.5197],[0.8223,0.5016],[0.8076,0.4851],[0.7918,0.4702],[0.7749,0.4567],[0.757,0.4445],[0.7383,0.4337],[0.7189,0.424],[0.6988,0.4154],[0.6782,0.4078],[0.6572,0.4011],[0.6359,0.3952],[0.6145,0.39],[0.5929,0.3855],[0.5715,0.3815],[0.5501,0.3779],[0.5291,0.3748],[0.5084,0.3718],[0.4835,0.3686],[0.4596,0.3653],[0.4368,0.3616],[0.4155,0.3574],[0.3959,0.3525],[0.3782,0.3468],[0.3625,0.3401],[0.3492,0.3323],[0.3385,0.3231],[0.3306,0.3124],[0.3256,0.3001],[0.3239,0.2859],[0.3254,0.2704],[0.3298,0.2568],[0.3373,0.245],[0.3482,0.2351],[0.3625,0.227],[0.3805,0.2207],[0.4022,0.2162],[0.4279,0.2136],[0.4577,0.2127],[0.4788,0.2134],[0.4987,0.2157],[0.5175,0.2198],[0.5349,0.2256],[0.551,0.2334],[0.5656,0.2431],[0.5787,0.2551],[0.5902,0.2693],[0.6,0.2859],[0.6129,0.3063],[0.6256,0.3188],[0.6393,0.3241],[0.6557,0.3228],[0.6761,0.3155],[0.8169,0.2549],[0.8385,0.2442],[0.8527,0.2316],[0.8595,0.2166],[0.8588,0.1983],[0.8507,0.1761],[0.8422,0.1595],[0.833,0.1438],[0.8234,0.1288],[0.8131,0.1145],[0.8022,0.101],[0.7907,0.0882],[0.7785,0.0762],[0.7657,0.0648],[0.7522,0.0542],[0.7381,0.0444],[0.7232,0.0352],[0.7076,0.0268],[0.6912,0.019],[0.6741,0.012],[0.6562,0.0056],[0.6376,-0.0001],[0.6181,-0.005],[0.5978,-0.0093],[0.5766,-0.013],[0.5546,-0.0159],[0.5318,-0.0182],[0.508,-0.0198],[0.4833,-0.0208],[0.4577,-0.0211],[0.4248,-0.0205],[0.393,-0.0185],[0.3625,-0.0152],[0.3333,-0.0107],[0.3055,-0.0049],[0.2789,0.002],[0.2536,0.0101],[0.2297,0.0193],[0.2072,0.0297],[0.186,0.0411],[0.1661,0.0535],[0.1477,0.0669],[0.1307,0.0813],[0.1151,0.0966],[0.1009,0.1128],[0.0881,0.1299],[0.0768,0.1479],[0.067,0.1666],[0.0586,0.1862],[0.0517,0.2064],[0.0464,0.2274],[0.0425,0.2491],[0.0402,0.2714]]]}]};
  /* LENS en relief dessiné : contour rouge non rempli, profondeur hachurée qui suit la souris.
     Formes : contours Panton 900 aplatis (hauteur de capitale = 1). */
  function Word3D(canvas, data, o){
    o = o || {};
    var ctx = canvas.getContext('2d'), red = o.color || '#DF0036';
    var track = o.track == null ? 0.05 : o.track;
    var L = [], x = 0, minX = 1e9, maxX = -1e9;
    function area(c){ var s = 0; for (var i = 0; i < c.length; i++){ var a = c[i], b = c[(i + 1) % c.length]; s += a[0] * b[1] - b[0] * a[1]; } return s / 2; }
    function rnd(s){ s = Math.sin(s * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); }
    data.letters.forEach(function(g, li){
      var cs = g.contours.map(function(c){
        var p = c.map(function(q){ return [q[0] + x, q[1]]; });
        if (area(p) < 0) p.reverse();
        p.forEach(function(q){ minX = Math.min(minX, q[0]); maxX = Math.max(maxX, q[0]); });
        return p;
      });
      L.push({cs: cs}); x += g.adv + track;
    });
    // décalage pour que le mot commence à 0
    L.forEach(function(l){ l.cs.forEach(function(c){ c.forEach(function(q){ q[0] -= minX; }); }); });
    var W = maxX - minX;
    // échantillons de hachure (fixes) et arêtes vives
    var lightDir = [0.6, -0.8];
    L.forEach(function(l, li){
      l.samples = []; l.corners = []; l.len = [];
      l.cs.forEach(function(c, ci){
        var n = c.length, nrm = [], seg = [], per = 0;
        for (var i = 0; i < n; i++){
          var a = c[i], b = c[(i + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], d = Math.hypot(dx, dy) || 1e-9;
          nrm.push([dy / d, -dx / d]); seg.push(d); per += d;
        }
        l.len.push(per);
        var ink = 0.37 + rnd(li * 7 + ci);
        for (var i = 0; i < n; i++){
          var a = c[i], b = c[(i + 1) % n], nn = nrm[i];
          var shade = 0.5 - 0.5 * (nn[0] * lightDir[0] + nn[1] * lightDir[1]);
          var sp = 0.085 - 0.06 * shade;           // espacement : faces à l'ombre plus serrées
          var t = 0;
          while (true){
            var need = (1 - ink) * sp;
            if (t + need > seg[i]){ ink += (seg[i] - t) / sp; break; }
            t += need; ink = 0;
            var f = t / seg[i], k = l.samples.length + li * 1000;
            l.samples.push({p: [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f], n: nn,
              j0: 0.04 + rnd(k) * 0.1, j1: 0.02 + rnd(k + .5) * 0.12, al: 0.62 + rnd(k + .25) * 0.38, d: rnd(k + .75)});
          }
        }
        // arêtes : virage fort sur une courte distance (coins arrondis compris)
        var i = 0;
        while (i < n){
          var turn = function(k){ var p = nrm[(k - 1 + n) % n], q = nrm[k]; return Math.atan2(p[0] * q[1] - p[1] * q[0], p[0] * q[0] + p[1] * q[1]); };
          var tk = turn(i);
          if (Math.abs(tk) > 0.04){
            var j = i, tot = 0, len = 0;
            while (j < i + n && Math.abs(turn(j % n)) > 0.04 && len < 0.09){ tot += turn(j % n); if (j > i) len += seg[(j - 1) % n]; j++; }
            if (Math.abs(tot) > 0.75){
              // point médian de l'arc
              var mid = Math.floor((i + j - 1) / 2) % n, pm = c[mid];
              if ((j - 1 - i) % 2 === 1){ var q2 = c[(mid + 1) % n]; pm = [(pm[0] + q2[0]) / 2, (pm[1] + q2[1]) / 2]; }
              l.corners.push({p: pm, n1: nrm[(i - 1 + n) % n], n2: nrm[(j - 1) % n]});
            }
            i = Math.max(j, i + 1);
          } else i++;
        }
      });
    });
    var self = {W: W, H: 1, letters: L};
    // dessin : ox, oy, s = position et taille (px CSS par unité), v = profondeur (unités), prog 0..1 (apparition)
    self.draw = function(ox, oy, s, v, w, prog, dpr){
      prog = prog == null ? 1 : prog;
      var cw = canvas.width, ch = canvas.height;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cw, ch);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineJoin = 'round'; ctx.lineCap = 'round'; ctx.strokeStyle = red; ctx.fillStyle = red;
      function P(q){ return [ox + q[0] * s, oy + q[1] * s]; }
      var pOut = Math.min(1, prog / .42), pDep = Math.max(0, Math.min(1, (prog - .36) / .4)), pHat = Math.max(0, (prog - .52) / .48);
      var e = 1 - Math.pow(1 - pDep, 3), vx = v[0] * e, vy = v[1] * e, vl = Math.hypot(vx, vy) || 1e-9;
      // 1 · silhouette du volume (contour extérieur)
      if (e > 0.001){
        var paths = L.map(function(l){
          var p = new Path2D();
          l.cs.forEach(function(c){
            var n = c.length, i, a, b;
            p.moveTo.apply(p, P(c[0])); for (i = 1; i < n; i++) p.lineTo.apply(p, P(c[i])); p.closePath();
            p.moveTo.apply(p, P([c[0][0] + vx, c[0][1] + vy])); for (i = 1; i < n; i++) p.lineTo.apply(p, P([c[i][0] + vx, c[i][1] + vy])); p.closePath();
            for (i = 0; i < n; i++){
              a = c[i]; b = c[(i + 1) % n];
              var q = [a, b, [b[0] + vx, b[1] + vy], [a[0] + vx, a[1] + vy]];
              if ((b[0] - a[0]) * vy - (b[1] - a[1]) * vx < 0) q.reverse();
              p.moveTo.apply(p, P(q[0])); p.lineTo.apply(p, P(q[1])); p.lineTo.apply(p, P(q[2])); p.lineTo.apply(p, P(q[3])); p.closePath();
            }
          });
          return p;
        });
        ctx.lineWidth = w * 2;
        paths.forEach(function(p){ ctx.stroke(p); ctx.fill(p); });
        ctx.globalCompositeOperation = 'destination-out';
        paths.forEach(function(p){ ctx.fill(p); });
        ctx.globalCompositeOperation = 'source-over';
      }
      // 2 · hachures des faces visibles, puis arêtes
      if (pHat > 0 && e > 0.02){
        ctx.lineWidth = Math.max(0.6, w * 0.42);
        L.forEach(function(l){
          l.samples.forEach(function(sm){
            var f = (sm.n[0] * vx + sm.n[1] * vy) / vl; if (f <= 0.02) return;
            var g = Math.max(0, Math.min(1, (pHat - sm.d * .55) / .45)); if (g <= 0) return;
            var a = Math.min(1, f / .3) * sm.al * g;
            var p0 = P([sm.p[0] + vx * sm.j0, sm.p[1] + vy * sm.j0]), k = sm.j0 + (1 - sm.j0 - sm.j1) * g;
            var p1 = P([sm.p[0] + vx * k, sm.p[1] + vy * k]);
            ctx.globalAlpha = a; ctx.beginPath(); ctx.moveTo(p0[0], p0[1]); ctx.lineTo(p1[0], p1[1]); ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
      if (e > 0.02){
        ctx.lineWidth = w * .9;
        L.forEach(function(l){
          l.corners.forEach(function(cn){
            var f1 = cn.n1[0] * vx + cn.n1[1] * vy, f2 = cn.n2[0] * vx + cn.n2[1] * vy;
            if (f1 <= 0 || f2 <= 0) return;
            ctx.globalAlpha = Math.min(1, Math.min(f1, f2) / vl / .25);
            var a = P(cn.p), b = P([cn.p[0] + vx, cn.p[1] + vy]);
            ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
      // 3 · faces avant : trait (dessiné au fil de l'apparition), intérieur vidé
      ctx.lineWidth = w * 2;
      L.forEach(function(l){
        l.cs.forEach(function(c, ci){
          var p = new Path2D(); p.moveTo.apply(p, P(c[0])); for (var i = 1; i < c.length; i++) p.lineTo.apply(p, P(c[i])); p.closePath();
          if (pOut < 1){ var per = l.len[ci] * s; ctx.setLineDash([per * pOut, per + 10]); }
          ctx.stroke(p); ctx.setLineDash([]);
          ctx.globalCompositeOperation = 'destination-out'; ctx.fill(p); ctx.globalCompositeOperation = 'source-over';
        });
      });
    };
    return self;
  }
/* Palmiers de Californie (Washingtonia : tronc très fin, couronne en éventails, jupe de palmes sèches),
     dessinés au trait rouge comme le LENS. Une scène = liste de traits {pts, w, d (délai d'apparition 0..1)}. */
  function Palms(canvas, o){
    o = o || {};
    var ctx = canvas.getContext('2d'), red = o.color || '#DF0036';
    function rnd(s){ s = Math.sin(s * 91.37 + 17.13) * 43758.5453; return s - Math.floor(s); }
    function qpt(a, c, b, t){ var m = 1 - t; return [m * m * a[0] + 2 * m * t * c[0] + t * t * b[0], m * m * a[1] + 2 * m * t * c[1] + t * t * b[1]]; }
    function qtan(a, c, b, t){ var x = 2 * (1 - t) * (c[0] - a[0]) + 2 * t * (b[0] - c[0]), y = 2 * (1 - t) * (c[1] - a[1]) + 2 * t * (b[1] - c[1]), l = Math.hypot(x, y) || 1; return [x / l, y / l]; }
    function curve(a, c, b, n){ var r = []; for (var i = 0; i <= n; i++) r.push(qpt(a, c, b, i / n)); return r; }
    function build(p, seed){
      var S = [], B = p.base, T = p.top, C = p.ctrl, U = p.unit, k = 0;
      function R(){ return rnd(seed * 3.1 + (k++) * 1.618); }
      // tronc : deux traits fins, légèrement irréguliers
      var n = 60, L = [], Rr = [], mid = [];
      for (var i = 0; i <= n; i++){
        var t = i / n, c = qpt(B, C, T, t), tg = qtan(B, C, T, t), nm = [-tg[1], tg[0]];
        var w = U * (0.062 - 0.024 * t) * (1 + 0.05 * Math.sin(t * 23 + seed));
        L.push([c[0] + nm[0] * w, c[1] + nm[1] * w]); Rr.push([c[0] - nm[0] * w, c[1] - nm[1] * w]); mid.push({c: c, nm: nm, w: w, tg: tg});
      }
      S.push({pts: L, w: 1, d: 0}); S.push({pts: Rr, w: 1, d: 0.01});
      // anneaux (petits arcs) et ombre côté p.shade
      var t2 = 0.03;
      while (t2 < 0.9){
        var m = mid[Math.round(t2 * n)], ring = [], sag = m.w * 0.5;
        for (var j = 0; j <= 6; j++){ var u = -0.9 + 1.8 * j / 6, f = 1 - u * u; ring.push([m.c[0] + m.nm[0] * m.w * u - m.tg[0] * sag * f, m.c[1] + m.nm[1] * m.w * u - m.tg[1] * sag * f]); }
        S.push({pts: ring, w: .5, d: 0.04 + t2 * 0.3});
        var a1 = mid[Math.min(n, Math.round((t2 + 0.02) * n))], uu = p.shade * 0.55;
        S.push({pts: [[m.c[0] + m.nm[0] * m.w * uu, m.c[1] + m.nm[1] * m.w * uu], [a1.c[0] + a1.nm[0] * a1.w * uu, a1.c[1] + a1.nm[1] * a1.w * uu]], w: .45, d: 0.06 + t2 * 0.3});
        t2 += 0.034 + 0.012 * R();
      }
      // couronne : palmes en feuilles pointues (remplies de blanc pour masquer ce qui est derrière),
      // nervure centrale, hachures côté ombre et bord dentelé
      var fr = p.fronds || [[-150,.95],[-118,.7],[-90,.55],[-62,.72],[-30,.98],[-178,1.05],[-2,1.08],[160,.8],[22,.82]];
      // une palme qui toucherait un texte, le mot ou une carte est raccourcie (ou retirée)
      var avoid = p.avoid || [];
      function hits(pts){
        for (var i = 0; i < pts.length; i += 2){ var q = pts[i];
          for (var r = 0; r < avoid.length; r++){ var A = avoid[r]; if (q[0] > A[0] && q[0] < A[2] && q[1] > A[1] && q[1] < A[3]) return true; } }
        return false;
      }
      fr.forEach(function(f, fi){
        for (var sc = 1; sc >= 0.35; sc -= 0.13){
          var out = frond(f, fi, sc);
          if (!hits(out.pts)){ out.strokes.forEach(function(x){ S.push(x); }); return; }
        }
      });
      function frond(f, fi, sc){
        var S = [], all = [];
        var ang = f[0] * Math.PI / 180, L2 = U * f[1] * sc, dir = [Math.cos(ang), Math.sin(ang)], hz = Math.abs(dir[0]);
        var E = [T[0] + dir[0] * L2, T[1] + dir[1] * L2 + L2 * (0.18 + 0.42 * hz * hz)];
        var Cc = [T[0] + dir[0] * L2 * 0.55, T[1] + dir[1] * L2 * 0.55 - L2 * (0.18 + 0.1 * hz)];
        var N = 44, up = [], dn = [], spine = [];
        for (var i3 = 0; i3 <= N; i3++){
          var tt = i3 / N, pt = qpt(T, Cc, E, tt), tg = qtan(T, Cc, E, tt), nm = [-tg[1], tg[0]];
          if (nm[1] < 0) nm = [-nm[0], -nm[1]];                 // nm pointe vers le bas (côté ombre)
          var wd = U * 0.088 * Math.pow(Math.sin(Math.PI * Math.min(1, tt * 1.05)), 0.75) * (1 - 0.25 * tt);
          // dentelure : pointes des folioles inclinées vers l'extrémité de la palme
          var tooth = i3 % 2 ? 1 : 0.72, fw = i3 % 2 ? wd * 0.35 : 0;
          spine.push(pt);
          up.push([pt[0] - nm[0] * wd * tooth + tg[0] * fw, pt[1] - nm[1] * wd * tooth + tg[1] * fw]);
          dn.push([pt[0] + nm[0] * wd * tooth + tg[0] * fw, pt[1] + nm[1] * wd * tooth + tg[1] * fw]);
        }
        var outline = up.concat(dn.slice().reverse());
        var d0 = 0.42 + 0.03 * fi;
        S.push({pts: outline, w: .9, d: d0, fill: true});
        S.push({pts: spine.slice(0, N - 1), w: .55, d: d0 + .04});
        // hachures : de la nervure vers le bord bas, inclinées vers la pointe
        for (var h3 = 4; h3 < N - 3; h3 += 3){
          var a0 = spine[h3], b0 = dn[Math.min(N, h3 + 3)];
          S.push({pts: [[a0[0] + (b0[0] - a0[0]) * .12, a0[1] + (b0[1] - a0[1]) * .12], [a0[0] + (b0[0] - a0[0]) * .9, a0[1] + (b0[1] - a0[1]) * .9]], w: .42, d: d0 + .08 + h3 / N * .1});
        }
        S.forEach(function(x){ all = all.concat(x.pts); });
        return {strokes: S, pts: all};
      }
      return S;
    }
    var scenes = [];
    return {
      set: function(list){ scenes = list.map(function(p, i){ return build(p, (i + 1) * 13.7); }); },
      draw: function(dpr, w, prog, ox, oy){
        prog = prog == null ? 1 : prog;
        ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.setTransform(dpr, 0, 0, dpr, (ox || 0) * dpr, (oy || 0) * dpr);
        ctx.strokeStyle = red; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        scenes.forEach(function(S){
          S.forEach(function(st){
            var g = Math.max(0, Math.min(1, (prog - st.d * 0.8) / 0.2)); if (g <= 0) return;
            var pts = st.pts, nn = Math.max(1, Math.round((pts.length - 1) * g));
            ctx.lineWidth = Math.max(0.5, w * st.w); ctx.globalAlpha = st.w < .5 ? .85 : 1;
            ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]);
            if (st.fill){
              for (var i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
              ctx.closePath();
              ctx.save(); ctx.globalAlpha = Math.min(1, g * 1.4); ctx.globalCompositeOperation = 'destination-out'; ctx.fill(); ctx.restore();
              ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]);
            }
            for (var i = 1; i <= nn; i++) ctx.lineTo(pts[i][0], pts[i][1]);
            if (st.fill && g >= 1) ctx.closePath();
            ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
    };
  }
  var hero = document.querySelector('[data-hero]');
  if (hero){
    var hIn = hero.querySelector('.lx-in'), wbox = hero.querySelector('.lx-wordbox'), cv = hero.querySelector('.lx-word');
    var girl = hero.querySelector('.lx-girl'), hdm = hero.querySelector('.lx-damier');
    // hauteur disponible : tout l'écran sous l'en-tête (bandeau compris)
    function top0(){ hero.style.setProperty('--top0', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px'); }
    top0();
    var W3 = null, dpr = 1, prog = reduce ? 1 : 0, started = false;
    try { if (cv.getContext && cv.getContext('2d')) W3 = Word3D(cv, GLYPHS, {track:.06, color:'#DF0036'}); } catch(e){ W3 = null; }
    if (!W3) hero.querySelector('.lx-word-fb').style.display = 'block';
    var V0 = [.065, .12], hx = 0, hy = 0, gx = 0, gy = 0, hsp = 0, hRun = false, hVis = true;
    // palmiers dessinés : ils sortent des bords de l'écran, dans les coins laissés libres par le texte
    var pcv = hero.querySelector('.lx-palms'), PL = null, pW = 1.4, palmsOn = true;
    var wideQ = window.matchMedia('(min-width: 1024px) and (min-aspect-ratio: 1/1)');
    try { if (pcv && pcv.getContext && pcv.getContext('2d')) PL = Palms(pcv, {color:'#DF0036'}); } catch(e){ PL = null; }
    function layoutPalms(){
      if (!PL || !wideQ.matches) return;
      if (!palmsOn){ return; }
      var r = pcv.getBoundingClientRect(), d = Math.min(2, window.devicePixelRatio || 1);
      pcv.width = Math.max(1, Math.round(r.width * d)); pcv.height = Math.max(1, Math.round(r.height * d));
      var inR = hIn.getBoundingClientRect(), pad = parseFloat(getComputedStyle(hIn).paddingLeft) || 0;
      var cL = inR.left + pad, cR = inR.right - pad;
      // assez de marge pour qu'on lise un palmier, pas un fragment
      var tg = document.querySelector('[data-palms-toggle]'); if (tg) tg.hidden = cL < 90;
      pcv.style.visibility = cL < 90 ? 'hidden' : ''; if (cL < 90) return;
      var eb = hero.querySelector('.lx-l .eyebrow').getBoundingClientRect(), crd = hero.querySelector('.lx-r').getBoundingClientRect();
      var top = hero.getBoundingClientRect().top, dmT = hdm.getBoundingClientRect().top;
      function U0(room){ return Math.max(120, Math.min(300, Math.min(cL * 1.6, (room - 10) / 1.05))); }
      var Ul = U0(eb.top - top), Ur = U0(crd.top - top);
      var Tl = [cL - Ul * .55, eb.top - Ul * .7 - 8], Tr = [cR + Ur * .55, crd.top - Ur * .7 - 8];
      var ox = r.left, oy = r.top, avoid = [];
      function add(b, m){ avoid.push([b.left - ox - m, b.top - oy - m, b.right - ox + m, b.bottom - oy + m]); }
      var ol = hero.querySelector('.lx .crumbs ol'), li = ol.lastElementChild.getBoundingClientRect(), ob = ol.getBoundingClientRect();
      add({left: ob.left, top: ob.top, right: li.right, bottom: ob.bottom}, 12);
      [].forEach.call(hero.querySelectorAll('.lx-l > :not(.sr)'), function(e){ add(e.getBoundingClientRect(), 12); });
      add(crd, 12);
      var wb = wbox.getBoundingClientRect(), cap = wb.height;
      add({left: wb.left, top: wb.top, right: wb.right + cap * .2, bottom: wb.bottom + cap * .22}, 14);
      PL.set([
        {base:[Tl[0] + Ul * .38 - ox, dmT + 12 - oy], top:[Tl[0] - ox, Tl[1] - oy], ctrl:[Tl[0] + Ul * .42 - ox, (Tl[1] + dmT) / 2 - oy], unit:Ul, shade:1, avoid:avoid,
         fronds:[[-150,.95],[-118,.7],[-92,.55],[-64,.6],[-36,.8],[-178,1.05],[-6,1.04],[160,.8],[24,.82]]},
        {base:[Tr[0] - Ur * .38 - ox, dmT + 12 - oy], top:[Tr[0] - ox, Tr[1] - oy], ctrl:[Tr[0] - Ur * .42 - ox, (Tr[1] + dmT) / 2 - oy], unit:Ur, shade:-1, avoid:avoid,
         fronds:[[-30,.95],[-62,.7],[-88,.55],[-116,.6],[-144,.8],[-2,1.05],[-174,1.04],[20,.8],[156,.82]]}
      ]);
      pW = Math.max(1.1, Math.min(1.7, (Ul + Ur) / 2 * .0085)); pDpr = d;
      drawPalms();
    }
    var pDpr = 1, lastPP = -1;
    function drawPalms(){ if (PL && wideQ.matches && palmsOn) PL.draw(pDpr, pW, Math.max(0, Math.min(1, (prog - .3) / .7))); }
    function sizeCanvas(){
      if (!W3) return;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      var r = cv.getBoundingClientRect();
      cv.width = Math.max(1, Math.round(r.width * dpr)); cv.height = Math.max(1, Math.round(r.height * dpr));
      drawWord();
    }
    function drawWord(){
      if (!W3) return;
      var rb = wbox.getBoundingClientRect(), rc = cv.getBoundingClientRect();
      var s = rb.width / W3.W;
      W3.draw(rb.left - rc.left, rb.top - rc.top, s, [V0[0] + gx * .085, V0[1] + gy * .045 + hsp * .06], Math.max(1.15, s * .0108), prog, dpr);
    }
    function heroFrame(){
      var r = hero.getBoundingClientRect();
      hsp = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height)));
      if (!reduce){
        wbox.style.transform = 'translate3d(' + (-gx * 7).toFixed(1) + 'px,' + (-gy * 5 - hsp * 40).toFixed(1) + 'px,0)';
        girl.style.transform = 'translate3d(' + (-gx * 16).toFixed(1) + 'px,' + (gy * 7 + hsp * 60).toFixed(1) + 'px,0)';
        hdm.style.backgroundPositionX = (-window.scrollY * .6 - gx * 10).toFixed(1) + 'px';
        if (pcv) pcv.style.transform = 'translate3d(' + (-gx * 10).toFixed(1) + 'px,' + (-gy * 6 + hsp * 30).toFixed(1) + 'px,0)';
      }
      drawWord();
      if (prog !== lastPP){ lastPP = prog; drawPalms(); }
    }
    function hTick(){
      gx += (hx - gx) * .08; gy += (hy - gy) * .08;
      heroFrame();
      if (Math.abs(hx - gx) > .002 || Math.abs(hy - gy) > .002){ requestAnimationFrame(hTick); } else { hRun = false; }
    }
    function hKick(){ if (!hRun && hVis && started){ hRun = true; requestAnimationFrame(hTick); } }
    // apparition : le mot se dessine, la supportrice sort du damier
    function intro(){
      if (started) return; started = true;
      hero.classList.remove('wait'); hero.classList.add('ready');
      if (reduce || document.visibilityState === 'hidden'){ prog = 1; heroFrame(); return; }
      var t0 = performance.now(), D = 2000;
      (function step(now){
        prog = Math.min(1, (now - t0) / D); heroFrame();
        if (prog < 1) requestAnimationFrame(step);
      })(t0);
    }
    var gDone = false;
    function gReady(){ if (gDone) return; gDone = true; intro(); }
    function gLoaded(){ if (girl.decode){ girl.decode().then(gReady, gReady); setTimeout(gReady, 700); } else gReady(); }
    // image ratée (réseau, fichier pas encore disponible) : un second essai sans cache, puis jamais d'icône d'erreur
    var gTry = 0;
    girl.addEventListener('error', function(){
      if (gTry++ < 1){ var b = '?r=' + Date.now(); girl.srcset = girl.srcset.replace(/\.webp(?=\s)/g, '.webp' + b); girl.src = girl.src.split('?')[0] + b; return; }
      hero.classList.add('g-err'); gReady();
    });
    girl.addEventListener('load', function(){ hero.classList.remove('g-err'); if (gDone) return; gLoaded(); });
    if (girl.complete && girl.naturalWidth) gLoaded();
    else if (girl.complete && !girl.naturalWidth && girl.currentSrc) girl.dispatchEvent(new Event('error'));
    setTimeout(gReady, 3500);
    sizeCanvas(); layoutPalms();
    window.addEventListener('resize', function(){ top0(); sizeCanvas(); layoutPalms(); heroFrame(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ top0(); sizeCanvas(); layoutPalms(); });
    // prototype : comparer avec et sans palmiers
    var pt = document.querySelector('[data-palms-toggle]');
    if (pt) pt.addEventListener('click', function(){
      palmsOn = !palmsOn; hero.classList.toggle('no-palms', !palmsOn);
      pt.setAttribute('aria-pressed', palmsOn); pt.textContent = 'Palmiers : ' + (palmsOn ? 'oui' : 'non');
      if (palmsOn) layoutPalms();
    });
    inView(hero, function(v){ hVis = v; if (v) hKick(); });
    if (!reduce){
      window.addEventListener('pointermove', function(e){
        if (!fine.matches) return;
        hx = Math.max(-1, Math.min(1, (e.clientX / window.innerWidth) * 2 - 1));
        hy = Math.max(-1, Math.min(1, (e.clientY / window.innerHeight) * 2 - 1));
        hKick();
      }, {passive:true});
      window.addEventListener('scroll', function(){ if (hVis && started) { if (!hRun) heroFrame(); } }, {passive:true});
    }
    // carte « prochain match »
    var hm = hero.querySelector('[data-hero-match]');
    if (hm){
      var m = nextMatch(Date.now());
      if (!m){ hm.querySelector('[data-hm-k]').textContent = '[ Soirs de match à Bollaert ]'; hm.querySelector('[data-hm-opp]').parentNode.textContent = 'Calendrier à venir'; }
      else {
        hm.querySelector('[data-hm-opp]').textContent = m.f.opp;
        var tm = hm.querySelector('[data-hm-date]'); tm.textContent = matchLabel(m); tm.setAttribute('datetime', m.f.d);
        var dd = Math.ceil((m.t - Date.now()) / 864e5), j = hm.querySelector('[data-hm-j]');
        j.textContent = m.t <= Date.now() ? '· en cours' : (dd <= 1 && new Date(m.t).toDateString() === new Date().toDateString() ? '· ce soir' : '· J-' + dd);
      }
    }
  }

  /* ---- La carte : la photo du produit suit la souris au survol (ordinateur) ---- */
  var board = document.querySelector('[data-board]'), peek = document.querySelector('.bd-peek');
  if (board && peek && !reduce){
    var pim = peek.firstChild, px = 0, py = 0, qx = 0, qy = 0, pOn = false, pRun = false;
    [].forEach.call(board.querySelectorAll('li[data-img]'), function(li){
      li.addEventListener('pointerenter', function(e){
        if (e.pointerType !== 'mouse') return;
        pim.src = window.WF_ASSETS + li.dataset.img + '.webp' + (window.WF_V || ''); pOn = true; peek.classList.add('on');
        if (!pRun){ qx = e.clientX; qy = e.clientY; }
        go();
      });
      li.addEventListener('pointerleave', function(){ pOn = false; peek.classList.remove('on'); });
    });
    board.addEventListener('pointermove', function(e){ px = e.clientX; py = e.clientY; if (pOn) go(); }, {passive:true});
    window.addEventListener('scroll', function(){ if (pOn){ pOn = false; peek.classList.remove('on'); } }, {passive:true});
    function go(){ if (!pRun){ pRun = true; requestAnimationFrame(step); } }
    function step(){
      qx += (px - qx) * .18; qy += (py - qy) * .18;
      var w = peek.offsetWidth, x = qx + 28, y = qy - w / 2;
      if (x + w > window.innerWidth - 12) x = qx - w - 28;
      var rot = Math.max(-8, Math.min(8, (px - qx) * .12));
      peek.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg)';
      if (pOn && (Math.abs(px - qx) > .3 || Math.abs(py - qy) > .3)){ requestAnimationFrame(step); } else { pRun = false; }
    }
  }

  /* ---- La carte sur mobile : une catégorie à la fois ---- */
  var tabs = document.querySelector('.bd-tabs');
  if (tabs && board){
    tabs.addEventListener('click', function(e){
      var b = e.target.closest('button[data-cat]'); if (!b) return;
      board.dataset.cat = b.dataset.cat;
      [].forEach.call(tabs.querySelectorAll('button'), function(x){ x.setAttribute('aria-selected', String(x === b)); });
    });
  }

  /* ---- Plan : les trajets se dessinent à l'arrivée ; survol d'un repère = trajet surligné ---- */
  var map = document.querySelector('[data-map]');
  if (map){
    inView(map, function(v){ if (v) map.classList.add('in'); }, {threshold:.35});
    function hi(n, on){
      map.classList.toggle('hi-' + n, on);
      var g = map.querySelector('.mark[data-mark="' + n + '"]'); if (g) g.classList.toggle('hi', on);
      var li = document.querySelector('.marks li[data-mark="' + n + '"]'); if (li) li.classList.toggle('hi', on);
    }
    [].forEach.call(document.querySelectorAll('[data-mark]'), function(el){
      var n = el.dataset.mark;
      el.addEventListener('pointerenter', function(){ hi(n, true); });
      el.addEventListener('pointerleave', function(){ hi(n, false); });
    });
  }

  /* ---- Le lieu : défilement horizontal piloté par le scroll vertical (ordinateur) ---- */
  var zp = document.querySelector('[data-zones]');
  if (zp){
    var zvp = zp.querySelector('[data-zones-viewport]'), ztr = zp.querySelector('[data-zones-track]'), zbar = zp.querySelector('[data-zones-bar]');
    var zimgs = [].slice.call(ztr.querySelectorAll('figure img')), zmax = 0;
    function zlayout(){
      if (desk.matches && !reduce){
        zp.classList.add('pinned');
        var st = zp.querySelector('.zones-sticky'), cs = getComputedStyle(zvp);
        zmax = Math.max(0, ztr.scrollWidth - (zvp.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)));
        zp.style.height = (st.offsetHeight + zmax) + 'px';
      } else { zp.classList.remove('pinned'); zp.style.height = ''; ztr.style.transform = ''; zmax = 0; zimgs.forEach(function(im){ im.style.transform = ''; }); }
      zscroll();
    }
    function zscroll(){
      var p;
      if (zp.classList.contains('pinned')){
        var r = zp.getBoundingClientRect(), total = zp.offsetHeight - zp.querySelector('.zones-sticky').offsetHeight;
        p = total > 0 ? Math.min(1, Math.max(0, (hdrH() - r.top) / total)) : 0;
        ztr.style.transform = 'translate3d(' + (-p * zmax).toFixed(1) + 'px,0,0)';
        // la photo glisse moins vite que sa carte : effet de profondeur
        var vw = window.innerWidth;
        zimgs.forEach(function(im){ var b = im.parentNode.getBoundingClientRect(); var c = (b.left + b.width / 2) / vw - .5; im.style.transform = 'translate3d(' + (-c * 9).toFixed(2) + '%,0,0)'; });
      } else { var m = zvp.scrollWidth - zvp.clientWidth; p = m > 0 ? zvp.scrollLeft / m : 0; }
      if (zbar) zbar.style.width = (12 + p * 88).toFixed(1) + '%';
    }
    var zt = false;
    window.addEventListener('scroll', function(){ if (!zt){ zt = true; requestAnimationFrame(function(){ zscroll(); zt = false; }); } }, {passive:true});
    zvp.addEventListener('scroll', zscroll, {passive:true});
    window.addEventListener('resize', zlayout);
    zimgs.forEach(function(im){ if (!im.complete) im.addEventListener('load', zlayout, {once:true}); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(zlayout);
    zlayout();
  }

  /* ---- Soir de match : prochain match à domicile et compte à rebours ---- */
  var tk = document.querySelector('[data-match]');
  if (tk){
    var U = {}; [].forEach.call(tk.querySelectorAll('[data-u]'), function(b){ U[b.dataset.u] = b; });
    function paint(){
      var now = Date.now(), m = nextMatch(now);
      if (!m){ tk.querySelector('[data-match-k]').textContent = 'Calendrier à venir'; return; }
      tk.querySelector('[data-opp]').textContent = m.f.opp;
      var txt = matchLabel(m);
      tk.querySelector('[data-mdate]').textContent = txt;
      var left = m.t - now, k = tk.querySelector('[data-match-k]');
      if (left <= 0){ k.textContent = 'Match en cours à Bollaert'; left = 0; } else { k.textContent = 'Prochain match à Bollaert'; }
      var s = Math.floor(left / 1000);
      U.d.textContent = Math.floor(s / 86400); U.h.textContent = String(Math.floor(s % 86400 / 3600)).padStart(2, '0');
      U.m.textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0'); U.s.textContent = String(s % 60).padStart(2, '0');
    }
    paint(); setInterval(paint, 1000);
  }

  /* ---- Envie de quoi ? : les produits apparaissent sous la souris (ou le doigt) ---- */
  var ts = document.querySelector('[data-trail]');
  if (ts && !reduce){
    var SRC = ['smash-burger-the-1976-woodys-factory','milkshake-the-real-shake-creme-glacee-woodys-factory','frites-wavy-fries-woodys-factory','cookie-kinder-maison-woodys-factory','smash-burger-the-trucker-bacon-woodys-factory','soda-signature-sprite-violette-woodys-factory','smash-burger-the-golden-goat-chevre-woodys-factory','frites-cheddar-fries-woodys-factory','cookie-dough-pate-a-cookie-woodys-factory','smash-burger-the-redwood-woodys-factory','onion-rings-woodys-factory','milkshake-cafe-the-coffee-shake-woodys-factory','burger-the-melt-brioche-woodys-factory','soda-signature-coca-cola-mangue-woodys-factory','cookie-chocolat-blanc-macadamia-woodys-factory','mac-and-cheese-balls-woodys-factory'];
    var pool = [], idx = 0, lx = null, ly = null, auto = 0, lastUser = 0, tv = false;
    for (var i = 0; i < 14; i++){
      var n = document.createElement('span'); n.className = 'trail-img'; n.setAttribute('aria-hidden', 'true'); n.style.opacity = '0';
      var im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; n.appendChild(im); ts.appendChild(n); pool.push(n);
    }
    function spawn(x, y, speed){
      var n = pool[idx % pool.length], im = n.firstChild; idx++;
      var name = SRC[idx % SRC.length]; im.src = window.WF_ASSETS + name + '.webp' + (window.WF_V || '');
      var w = n.offsetWidth || 160, rot = (Math.random() * 16 - 8).toFixed(1), sc = Math.min(1.15, .8 + speed * .012);
      n.getAnimations && n.getAnimations().forEach(function(a){ a.cancel(); });
      n.style.zIndex = String(10 + idx % 500);
      var from = 'translate(' + (x - w / 2) + 'px,' + (y - w / 2) + 'px)';
      n.animate([
        {transform: from + ' scale(.3) rotate(' + rot + 'deg)', opacity:0},
        {transform: from + ' scale(' + sc + ') rotate(' + rot + 'deg)', opacity:1, offset:.22},
        {transform: from + ' scale(' + sc + ') rotate(' + rot + 'deg)', opacity:1, offset:.6},
        {transform: 'translate(' + (x - w / 2) + 'px,' + (y - w / 2 + 40) + 'px) scale(.5) rotate(' + (-rot) + 'deg)', opacity:0}
      ], {duration:1500, easing:'cubic-bezier(.16,1,.3,1)', fill:'forwards'});
    }
    function at(cx, cy, fromUser){
      var r = ts.getBoundingClientRect(), x = cx - r.left, y = cy - r.top;
      if (lx === null){ lx = x; ly = y; return; }
      var d = Math.hypot(x - lx, y - ly);
      if (d > 90){ spawn(x, y, d); lx = x; ly = y; }
      if (fromUser){ lastUser = Date.now(); var h = ts.querySelector('[data-trail-hint]'); if (h) h.style.opacity = '0'; }
    }
    ts.addEventListener('pointermove', function(e){ at(e.clientX, e.clientY, true); }, {passive:true});
    ts.addEventListener('pointerleave', function(){ lx = null; });
    var hint = ts.querySelector('[data-trail-hint]'); if (hint && !fine.matches) hint.textContent = 'Glissez le doigt.';
    // démonstration automatique quand la section arrive et que personne ne bouge
    function demo(){
      if (!tv || Date.now() - lastUser < 2500) return;
      var r = ts.getBoundingClientRect(), t0 = performance.now(); lx = null;
      (function step(t){
        var k = (t - t0) / 2600; if (k > 1 || Date.now() - lastUser < 500){ lx = null; return; }
        var a = k * Math.PI * 2;
        at(r.left + r.width * (.5 + .36 * Math.sin(a)), r.top + r.height * (.5 + .26 * Math.sin(2 * a)), false);
        requestAnimationFrame(step);
      })(t0);
    }
    inView(ts, function(v){ tv = v; if (v){ clearInterval(auto); setTimeout(demo, 500); auto = setInterval(demo, fine.matches ? 9000 : 6000); } else { clearInterval(auto); } }, {threshold:.45});
  }
})();


/* Encart Miami : « Miami » s'allume et les stickers se posent à l'arrivée ; compte à rebours et libellés (heure de Paris) ;
   retrait après le 30/11. Mouvement réduit respecté. */
(function(){
  var me = document.querySelector('[data-me]'); if (!me) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var START = Date.parse('2026-11-02T11:30:00+01:00'), END = Date.parse('2026-11-30T23:59:59+01:00');
  var k = me.querySelector('[data-me-k]'), ck = me.querySelector('[data-me-ck]'), cnt = me.querySelector('[data-me-count]'), U = {};
  if (cnt) cnt.querySelectorAll('[data-u]').forEach(function(u){ U[u.getAttribute('data-u')] = u; });
  var two = function(n){ return (n < 10 ? '0' : '') + n; };
  var tick = function(){
    var now = Date.now();
    if (now > END){ me.hidden = true; return; }
    var pre = now < START, s = Math.floor(((pre ? START : END) - now) / 1000);
    if (k) k.textContent = pre ? '[\xa0Édition limitée · dès lundi 2 novembre\xa0]' : "[\xa0Édition limitée · jusqu'au 30 novembre\xa0]";
    if (ck) ck.textContent = pre ? '[\xa0Début du jeu dans\xa0]' : '[\xa0Fin du jeu dans\xa0]';
    if (U.d) U.d.textContent = Math.floor(s / 86400);
    if (U.h) U.h.textContent = two(Math.floor(s % 86400 / 3600));
    if (U.m) U.m.textContent = two(Math.floor(s % 3600 / 60));
  };
  tick(); setInterval(tick, 30000);
  if (!reduce && 'IntersectionObserver' in window){
    me.classList.add('is-armed');
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ me.classList.add('is-in'); io.disconnect(); } }); }, {threshold: .3});
    io.observe(me);
  }
})();
